import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { VerifyCode, LoginUser, ResetUser } from './store/actions';

import './assets/styles/Login.scss';
import Loader from '../commons/assets/loader';

function VerifyUser() {
  const authuser = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [code, setCode] = useState('');
  const [hasError, setHasError] = useState(false);
  const [codeResend, setCodeResend] = useState(false);

  useEffect(() => {
    if (!authuser) {
      goBack();
      return;
    }
    if (!authuser.data || !authuser.data.email) {
      navigate('/auth');
    }
    if (authuser.error) {
      setHasError(true);
      setCode('');
    }
    if (authuser.data && authuser.data.token) {
      navigate('/');
    }
  }, [authuser]);

  const loginSubmit = async () => {
    dispatch(VerifyCode({ code: Number(code) }));
  };

  const resendCode = async () => {
    setCodeResend(true);
    dispatch(LoginUser({ email: authuser.data.email }));
  };

  const goBack = async () => {
    dispatch(ResetUser({}));
    navigate('/auth', { replace: true });
  };

  const ErrorMessage = React.memo(() => {
    if (hasError && !codeResend && !code) {
      return <div className='error'>Code Verification Failed</div>;
    }
    return '';
  });

  return (
    <div className={'login_container'}>
      <div className='card'>
        <div className='card-title'>{authuser && authuser.data.email}</div>
        <ErrorMessage />
        {codeResend && <div className='success'>Code Resend</div>}
        <div className='card-sub-title'>Verification code has been sent to your email.</div>
        <div className='control'>
          <input
            name='code'
            value={code}
            placeholder='1234'
            onChange={(e) => setCode(e.target.value)}
            autoComplete={'off'}
          ></input>
        </div>
        {authuser?.loading ? (
          <Loader />
        ) : (
          <button
            className='button active'
            type='button'
            disabled={!code}
            onClick={loginSubmit}
          >
            Verify
          </button>
        )}
        <a href='#' onClick={resendCode}>
          Resend Code
        </a>
        <a href='#' onClick={goBack}>
          Go Back
        </a>
      </div>
    </div>
  );
}

export default VerifyUser;
